// activeCalibrationLogBook/slice.js

import { activeCalibrationLogBookInitialState } from "./activeCalibrationLogBookState";
import { makeActiveCalibrationLogBookActions } from "./activeCalibrationLogBookActions";

export const createActiveCalibrationLogBookSlice = (set, get) => ({
  activeCalibrationLogBook: activeCalibrationLogBookInitialState,
  activeCalibrationLogBookActions: Object.freeze(
    makeActiveCalibrationLogBookActions(set, get)
  ),
});
